import { useState } from "react";
import { axios } from "../boot";

export default function useGetCourse() {
  const [course, setCourse] = useState([]);
  const getCourses = () => {
    const url = "/admins/pub/shop/courses";
    axios.get(url).then((res) => {
      
      const data = res.data.data.map((e) => ({ ...e, isAdmin: true }));
      
      setCourse(data);
    });
  };
  return [course, getCourses];
}
